import { useModifiedDownloadContext } from '../contexts/ModifiedDownloadContext';

const useDownloadModifiedAsset = () => {
  const {
    genId,
    index,
    onModifiedDownloadSuccess,
    hasTransparency,
    assetLicense,
    downloadAgreements,
    hideALaCarte,
  } = useModifiedDownloadContext();

  const isUltrapackRedownloadable = (downloadAgreements?.agreements || [])
    .map((agreement) =>
      (agreement.authorizedSizes || []).map((size) => ({
        ...size,
        agreementType: agreement.type,
      }))
    )
    .flat()
    .some((size) => size.isFree && size.agreementType === 'ImagePack');

  return {
    genId,
    index,
    onModifiedDownloadSuccess,
    hasTransparency,
    assetLicense,
    downloadAgreements,
    isUltrapackRedownloadable,
    hideALaCarte,
  };
};

export default useDownloadModifiedAsset;
